import * as React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { userStore } from '../../store/UserStore';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CreateSubAccount from 'pages/profile/components/create-sub-account';
import CustomerOnboardingHttp from 'pages/customer-onboarding/services/customer.service';
import { toast } from 'react-toastify';
import "./style.css";
import Referral from 'pages/referral/Referral';

interface PropsType {
  mainTitle: string;
  subTitle: string;
  isShowSub?: boolean;
  isShowAccount?: boolean;
}

const GiftIcon = ({ size = 17 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="9" width="18" height="11" rx="1.5" />
    <path d="M3 13h18" />
    <path d="M12 9v11" />
    <path d="M12 9c0 0-2.5 0-3.5-1.5C7.7 6.3 8.3 4.5 9.8 4.2 11.2 3.9 12 5.5 12 6.5V9Z" />
    <path d="M12 9c0 0 2.5 0 3.5-1.5C16.3 6.3 15.7 4.5 14.2 4.2 12.8 3.9 12 5.5 12 6.5V9Z" />
  </svg>
);

const ArrowRightIcon = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={2}
    strokeLinecap='round'
    strokeLinejoin='round'
    {...props}
  >
    <line x1='5' y1='12' x2='19' y2='12' />
    <polyline points='12 5 19 12 12 19' />
  </svg>
);


const PageHeader: React.FC<PropsType> = ({
  mainTitle,
  subTitle,
  isShowSub = true,
  isShowAccount = true,
}) => {
  const [
    setSelectedAccount,
    selectedAccount,
    customer,
    customerId,
    customers,
    setCustomerId,
    setCustomer,
  ] = userStore((state: any) => [
    state.setSelectedAccount,
    state.selectedAccount,
    state.customer,
    state.customerId,
    state.customers,
    state.setCustomerId,
    state.setCustomer,
  ]);
  const history = useHistory();
  const [isShow, setIsShow] = React.useState(false);
  const [isSubOptionDisplayed, setIsSubOptionDisplayed] = React.useState(false);
  const [showRefer, setShowRefer] = React.useState(false);

  const onChangeAccount = (key: any, event: any) => {
    if (event.target.name === 'create_sub_account') {
      setIsShow(true);
    } else {
      let account = customer?.accounts.find(
        (item: any) => item.accountId === event.target.name
      );
      if (account) {
        setSelectedAccount(account);
      }
    }
  };

  useEffect(() => {
    if (customer.customerCategory === 'REGISTERED' && customer.companyGSTIN)
      getGstn(customer.customerId, customer?.kyc?.pan?.value);
  }, []);

  const getGstn = async (customerId, panNumber) => {
    try {
      const data = {
        customerId: customerId,
        pan: panNumber,
      };
      const res: any = await CustomerOnboardingHttp.getGstns(data);
      if (res.status === 200 && res.data.data) {
        if (customer.customerType !== 'IND') {
          if (res.data.data.gstins && res.data.data.gstins.length > 0) {
            const response = res.data.data.gstins.filter(
              (item) => item?.hasSubAccount === false
            );
            if (response.length > 0) setIsSubOptionDisplayed(true);
          }
        }
      } else {
        setIsSubOptionDisplayed(false);
        console.error('Something went wrong');
      }
    } catch (e: any) {
      setIsSubOptionDisplayed(false);
      console.error('Something went wrong');
    }
  };

  const handleAccountCanvas = (isShow) => {
    setIsShow(isShow);
  };

  return (
    <>
      <CreateSubAccount handleModal={handleAccountCanvas} isShow={isShow} />
      <div className='column-style main-title d-flex justify-content-lg-between justify-content-md-between justify-content-sm-start mb-3'>
        <div className=''>
          {isShowSub ? (
            <div className='dash__f-18'>
              Hi, {customer?.displayName}
            </div>
          ) : (
            ''
          )}
          <h5>{subTitle}</h5>
        </div>

        {isShowAccount && (
          <div className='refer-friend-banner'>
            <div className='refer-friend-banner__left'>
              <div className='refer-friend-banner__icon' aria-hidden='true'>
                <GiftIcon size={16} />
              </div>
              <div className='refer-friend-banner__text'>
                <p className='refer-friend-banner__title'>Refer & earn</p>
                <div className='refer-friend-banner__amount-row'>
                  <span className='refer-friend-banner__amount'>₹50</span>
                  <span className='refer-friend-banner__per'>per friend
                     <sup className='refer-friend-banner__sup'>*</sup>
                  </span>
                </div>
              </div>
            </div>
            <button
              type='button'
              className='refer-now-btn'
              onClick={() => setShowRefer(true)}
              aria-label='Refer a friend and earn ₹50'
            >
              Refer now
              <ArrowRightIcon size={14} className='refer-now-btn__arrow' aria-hidden='true' />
            </button>
          </div>
        )}

      </div>
      <Referral handleModal={() => setShowRefer(false)} isShow={showRefer} />
    </>
  );
};

export default React.memo(PageHeader);